<template>
  <DBox
    :id="'cmp-catalog-products-product_setup'"
    :sid="selectedProductDetails.product.product_id"
    :addButton="false"
    :expandable="true"
    :searchButton="true"
    :searchIcon="'static/icons/edit-blue.svg'"
    :searchIconAlt="'static/icons/edit-blue.svg'"
    @searchClick="onEditClick"
  >
    <TextField2
      :disabled="selectedProductDetails.disabled"
      :id="'catalog_no'"
      :placeholder="$t('catalog_no')"
      :label="$t('catalog_no')"
      :value="selectedProductDetails.product.catalog_no"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      :disabled="selectedProductDetails.disabled"
      v-if="
        isPhysical &&
        selectedProductDetails.product.alt_artist &&
        selectedProductDetails.product.alt_artist != ''
      "
      :id="'alt_artist'"
      :placeholder="$t('alt_artist')"
      :label="$t('alt_artist')"
      :value="selectedProductDetails.product.alt_artist"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      :disabled="selectedProductDetails.disabled"
      v-if="
        isPhysical &&
        selectedProductDetails.product.alt_title &&
        selectedProductDetails.product.alt_title != ''
      "
      :id="'alt_title'"
      :placeholder="$t('alt_title')"
      :label="$t('alt_title')"
      :value="selectedProductDetails.product.alt_title"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      :disabled="selectedProductDetails.disabled"
      v-if="
        isPhysical &&
        selectedProductDetails.product.release_shift &&
        selectedProductDetails.product.release_shift != ''
      "
      :id="'release_shift'"
      :placeholder="$t('release_shift')"
      :label="$t('release_shift')"
      :value="selectedProductDetails.product.release_shift"
      @blur="onTextFieldValueChange"
    />
    <!-- :hint="'Variable	  Description\t\t   \tExample\n#yyyy#	  for 4 digit year\t \t„2017\n#yy#\t  for 2 digit year\t \t„17\n#nr2#\t  for a 2 digit number	„01\n#nr3#\t  for a 3 digit number	„001“\n#nr4#\t  for a 4 digit number	„0001“'" -->
    <TextField2
      :disabled="selectedProductDetails.disabled"
      :id="'barcode'"
      :placeholder="$t('barcode')"
      :label="$t('barcode')"
      :value="selectedProductDetails.product.barcode"
      @blur="onTextFieldValueChange"
    />
    <Dropdown2
      :label="$t('format')"
      :placeholder="$t('choose') + ' ' + $t('format')"
      :disabled="selectedProductDetails.disabled"
      :options="selectedProductDetails.formatsTV"
      :selected="
        selectedProductDetails.formatsTV.find(
          (c) => c.value == selectedProductDetails.product.format_id
        )
      "
      v-on:selectedChange="(e) => onDropdownChange('format_id', e)"
    />
    <DatePicker2
      :disabled="selectedProductDetails.disabled"
      v-if="
        selectedProductDetails.product.preorder_date &&
        selectedProductDetails.product.preorder_date != ''
      "
      :id="'preorder_date'"
      :placeholder="$t('preorder_date')"
      :label="$t('preorder_date')"
      :value="selectedProductDetails.product.preorder_date"
      @input="onDateUpdate"
    />
    <!-- <TextField2
      :type="'date'"
      :disabled="selectedProductDetails.disabled"
      :id="'preorder_date'"
      :placeholder="$t('preorder_date')"
      :label="$t('preorder_date')"
      :value="selectedProductDetails.product.preorder_date"
      @blur="onTextFieldValueChange"
    /> -->

    <TextField2
      :disabled="selectedProductDetails.disabled"
      :id="'version'"
      :placeholder="$t('version')"
      :label="$t('version')"
      :value="selectedProductDetails.product.version"
      @blur="onTextFieldValueChange"
    />
    <DatePicker2
      :disabled="false"
      id="product_date"
      :label="$t('product_date')"
      :value="selectedProductDetails.product.product_date"
      @input="(e) => onDateChange(e)"
      :hint="$t('release_date_info')"
    />
    <!-- <TextField2
      :disabled="selectedProductDetails.disabled"
      :id="'version'"
      :placeholder="$t('version')"
      :label="$t('version')"
      :value="selectedProductDetails.product.version"
      @blur="onTextFieldValueChange"
    /> -->
    <TextField2
      :disabled="selectedProductDetails.disabled"
      :id="'identifier'"
      :placeholder="$t('identifier')"
      :label="$t('identifier')"
      :value="selectedProductDetails.product.identifier"
      @blur="onTextFieldValueChange"
    />

    <Dropdown2
      :label="$t('status')"
      :placeholder="$t('choose') + ' ' + $t('status')"
      :disabled="selectedProductDetails.disabled"
      :options="labelStatusTV"
      :selected="
        labelStatusTV.find(
          (c) => c.value == selectedProductDetails.product.label_status_id
        )
      "
      status
      v-on:selectedChange="(e) => onDropdownChange('label_status_id', e)"
    />

    <DatePicker2
      :disabled="false"
      v-if="selectedProductDetails.product.termination_date"
      id="termination_date"
      :label="'Termination Date'"
      :value="selectedProductDetails.product.termination_date"
      @input="(e) => onDateChange(e)"
    />



    <TextField2
      :disabled="true"
      :id="'label_name'"
      :placeholder="$t('label_name')"
      :label="$t('label_name')"
      :value="selectedProductDetails.product_more_info.label_name"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      :disabled="true"
      :id="'main_genre'"
      :placeholder="$t('main_genre')"
      :label="$t('main_genre')"
      :value="selectedProductDetails.product_more_info.main_genre"
      @blur="onTextFieldValueChange"
    />

    <TextField2
      :disabled="selectedProductDetails.disabled"
      :id="'product_grid'"
      :placeholder="$t('b2b_level3_grid')"
      :label="$t('b2b_level3_grid')"
      :value="selectedProductDetails.product.product_grid"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      :disabled="true"
      :id="'sub_genre'"
      :placeholder="$t('sub_genre')"
      :label="$t('sub_genre')"
      :value="selectedProductDetails.product_more_info.sub_genre"
      @blur="onTextFieldValueChange"
    />
  </DBox>
</template>

<script>
export default {
  props: {
    selectedProductDetails: {
      required: true,
    },
    isPhysical: {
      required: true,
    },
  },
  computed: {
    labelStatusTV: function () {
      console.log(
        "this.selectedProductDetails::::::",
        this.selectedProductDetails
      );

      return (
        this.selectedProductDetails?.label_statuses.map((e) => {
          return {
            color: `#${e.label_status_colour}`,
            value: e.label_status_id,
            text: e.label_status_name,
          };
        }) || []
      );
      //label_statuses
    },
  },

  methods: {
    onTextFieldValueChange: function (event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
    onDateChange: function (e) {
      const payload = {
        name: e.name,
        value: e.value,
      };
      this.$emit("changed", payload);
      console.log("WERERTYUPOIUN", payload);
    },
    onDropdownChange: function (name, value) {
      this.$emit("changed", { name, value: value.value });
    },
    onTopMenuClick(e) {
      alert("Menu Click");
    },
    onDateUpdate: function ({ name, value }) {
      this.$emit("changed", { name, value });
    },
    onEditClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "alternate_setup",
          product_id: this.selectedProductDetails.product.product_id,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.cmp-catalog-products-product_setup {
}
</style>
